export * from "./shared.module";
export * from "./animations/router.animations";

export * from "./services/authentication.service";
export * from "./services/main.service";
export * from "./services/data.service";
export * from "./services/inventory/master.service";
export * from "./services/inventory/in-products.service";
export * from "./services/inventory/in-purchases.service";
export * from "./services/inventory/in-sales.service";
export * from "./services/inventory/in-transactions.service";
export * from "./services/inventory/in-report.service";
export * from "./services/inventory/in-pos.service";

export * from "./services/accounts/ca-master.service";
export * from "./services/accounts/ca-trans.service";

export * from "./component/dialog/index";

export * from "./component/item-search/item-search.component";
export * from "./component/grid-edit/grid-edit.component";
export * from "./component/vchrprint/vchrprint.component";
export * from "./component/importfromfile/importfromfile.component";
export * from './component/table-popup/table-popup.component';
export * from './component/barcode-print/barcode-print.component';


export * from './component/rpt-fiter/rpt-fiter.component';
export * from './component/product-search/product-search.component'


export * from './component/rest-item-search/rest-item-search.component'
export * from './component/rest-combo-itemsearch/rest-combo-itemsearch.component';

export * from "./services/restaurant/rest-master.service";
export * from "./services/restaurant/rest-item.service";
export * from "./services/restaurant/rest-combo-item.service";
export * from "./services/restaurant/rest-recipe.service";
export * from "./component/supplier-search/supplier-search.component";
export * from "./component/chequeprint/chequeprint.component";
export * from "./component/chqprint/chqprint.component";
export * from "./component/userrole-search/userrole-search.component";
export * from "./component/privilege-search/privilege-search.component";
export * from "./component/transactionhistory/transactionhistory.component";
export * from "./component/mobilepdt-search/mobilepdt-search.component";
export * from "./component/purchasehistory/purchasehistory.component";
export * from "./component/item-master/item-master.component";
export * from "../lazy-modules/+private-page/inventory/products/product-grp/product/product.component";
export * from "./component/promotionaddbulk/promotionaddbulk.component";
export * from "./component/deleteitem/deleteitem.component";
export * from "./component/salescontact/salescontact.component";
export * from "./component/contact-search/contact-search.component";
export * from "./component/restcustomer-search/restcustomer-search.component";
export * from "./component/salescontacthistory/salescontacthistory.component";
export * from "./component/salesorder-search/salesorder-search.component";
export * from "./component/deliverynote-search/deliverynote-search.component";
export * from "./component/dnserach-bosale/dnserach-bosale.component";
export * from "./component/materialrequisition-search/materialrequisition-search.component"
export * from "./component/unpostsales/unpostsales.component"
export * from "./component/expirydetails-stock/expirydetails-stock.component"



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/index.ts